import {
  MenuItemsType,
  SwapIcon,
  SwapFillIcon,
  EarnFillIcon,
  EarnIcon,
  DropdownMenuItems,
  FaucetIcon,
  FaucetIconFill,
  BarChartIcon,
  AirDropFillIcon,
  AirDropIcon,
  AccountIcon,
  AccountFilledIcon,
  BridgeIcon,
} from '@pancakeswap/uikit'
import { ContextApi } from '@pancakeswap/localization'
import AirDrop from 'views/Airdrop'

export type ConfigMenuDropDownItemsType = DropdownMenuItems & { hideSubNav?: boolean }
export type ConfigMenuItemsType = Omit<MenuItemsType, 'items'> & { hideSubNav?: boolean; image?: string } & {
  items?: ConfigMenuDropDownItemsType[]
}

const addMenuItemSupported = (item, chainId) => {
  if (!chainId || !item.supportChainIds) {
    return item
  }
  if (item.supportChainIds?.includes(chainId)) {
    return item
  }
  return {
    ...item,
    disabled: true,
  }
}

const config: (
  t: ContextApi['t'],
  isDark: boolean,
  languageCode?: string,
  chainId?: number,
) => ConfigMenuItemsType[] = (t, isDark = true, languageCode, chainId = 167012) =>
  [
    {
      label: t('Swap'),
      icon: SwapIcon,
      fillIcon: SwapFillIcon,
      href: '/swap',
      showItemsOnMobile: false,
      items: [].map((item) => addMenuItemSupported(item, chainId)),
    },
    {
      label: t('Earn'),
      href: '/farms',
      icon: EarnIcon,
      fillIcon: EarnFillIcon,
      image: '/images/decorations/KF_05.png',
      items: [
        {
          label: t('Farms'),
          href: '/farms',
        },
        {
          label: t('Liquidity'),
          href: '/liquidity',
        },
      ].map((item) => addMenuItemSupported(item, chainId)),
    },
    {
      label: t('Analytics'),
      href: '/info/v3',
      image: '/images/decorations/KF_05.png',
      icon: BarChartIcon,
      fillIcon: BarChartIcon,
      showItemsOnMobile: false,
      items: [].map((item) => addMenuItemSupported(item, chainId)),
    },
    {
      label: t('Bridge'),
      href: '',
      image: '/images/decorations/KF_05.png',
      icon: BridgeIcon,
      fillIcon: BridgeIcon,
      items: [
        {
          label: t('Kaspa EVM Bridge'),
          href: 'https://kaspabridge.com/',
          target: '_blank',
        },
        {
          label: t('KAS Bridge'),
          href: 'https://kasbridge-evm.kaspafoundation.org/',
          target: '_blank',
        },
        {
          label: t('KRC20 Bridge'),
          href: 'https://katbridge.com/',
          target: '_blank',
        },
      ].map((item) => addMenuItemSupported(item, chainId)),
    },
    {
      label: t('Campaign'),
      href: '/dashboard',
      image: '/images/decorations/KF_05.png',
      icon: AccountIcon,
      fillIcon: AccountFilledIcon,
      showItemsOnMobile: false,
      items: [].map((item) => addMenuItemSupported(item, chainId)),
    },
    {
      label: t('Faucet'),
      href: '/faucets',
      icon: FaucetIcon,
      fillIcon: FaucetIconFill,
      image: '/images/decorations/KF_05.png',
      showItemsOnMobile: false,
      items: [].map((item) => addMenuItemSupported(item, chainId)),
    },
    {
      label: t('Airdrop'),
      href: '/airdrop',
      icon: AirDropIcon,
      fillIcon: AirDropFillIcon,
      image: '/images/decorations/KF_05.png',
      showItemsOnMobile: false,
      items: [].map((item) => addMenuItemSupported(item, chainId)),
    },
    // {
    //   label: t('Token'),
    //   href: '/token',
    //   image: '/images/decorations/KF_05.png',
    //   icon: AccountIcon,
    //   fillIcon: AccountFilledIcon,
    //   showItemsOnMobile: false,
    //   items: [].map((item) => addMenuItemSupported(item, chainId)),
    // },
  ].map((item) => addMenuItemSupported(item, chainId))

export default config
